"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CheckCircle = _interopRequireDefault(require("@mui/icons-material/CheckCircle"));

var _ThumbUp = _interopRequireDefault(require("@mui/icons-material/ThumbUp"));

var _Error = _interopRequireDefault(require("@mui/icons-material/Error"));

var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _Warning = _interopRequireDefault(require("@mui/icons-material/Warning"));

var _material = require("@mui/material");

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));

var _ui = require("@alycecom/ui");

var _useGlobalMessage2 = _interopRequireDefault(require("../hooks/useGlobalMessage"));

var useStyles = (0, _makeStyles["default"])(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    content: {
      margin: spacing(1),
      fontSize: spacing(2),
      flexWrap: 'nowrap',
      alignItems: 'flex-start'
    },
    success: {
      backgroundColor: palette.green.fruitSalad
    },
    good: {
      backgroundColor: palette.green.fruitSalad
    },
    error: {
      backgroundColor: palette.error.light
    },
    info: {
      backgroundColor: palette.primary.dark
    },
    warning: {
      backgroundColor: palette.secondary.main
    },
    close: {
      fontSize: 24
    },
    icon: {
      fontSize: 26,
      opacity: 0.9,
      marginRight: spacing(1),
      alignSelf: 'flex-start'
    },
    message: {
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'pre-line',
      paddingTop: 3
    }
  };
});
var iconType = {
  success: _CheckCircle["default"],
  warning: _Warning["default"],
  error: _Error["default"],
  info: _Info["default"],
  good: _ThumbUp["default"]
};
var position = {
  vertical: 'top',
  horizontal: 'center'
};

var MessageSnackbar = function MessageSnackbar() {
  var classes = useStyles();

  var _useGlobalMessage = (0, _useGlobalMessage2["default"])(),
      isSnackbarOpen = _useGlobalMessage.isSnackbarOpen,
      type = _useGlobalMessage.type,
      message = _useGlobalMessage.message,
      hideGlobalMessage = _useGlobalMessage.hideGlobalMessage,
      icon = _useGlobalMessage.icon;

  var Icon = iconType[type];
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_material.Snackbar, {
    anchorOrigin: position,
    open: isSnackbarOpen,
    onClose: hideGlobalMessage,
    ContentProps: {
      'aria-describedby': 'message-id'
    },
    autoHideDuration: 6000,
    "data-testid": "GlobalMessage.Snackbar"
  }, /*#__PURE__*/_react["default"].createElement(_material.SnackbarContent, {
    "aria-describedby": "client-snackbar",
    className: (0, _classnames["default"])(classes[type], classes.content),
    message: /*#__PURE__*/_react["default"].createElement("span", {
      id: "client-snackbar",
      className: classes.message
    }, icon ? /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      className: classes.icon,
      icon: icon
    }) : /*#__PURE__*/_react["default"].createElement(Icon, {
      className: classes.icon
    }), message),
    action: [/*#__PURE__*/_react["default"].createElement(_material.IconButton, {
      key: "close",
      "aria-label": "Close",
      color: "inherit",
      onClick: hideGlobalMessage,
      size: "large"
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      className: classes.close,
      "data-testid": "GlobalMessage.Snackbar.Close"
    }))]
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(MessageSnackbar);

exports["default"] = _default;